import '../../../scss/critical.scss';
import '../../../scss/entrypoints/pricing_page.scss';
import 'bootstrap/js/dist/collapse';
import '../../../scss/help.scss';
import { createApp } from 'vue';
import BuyCreditsBox from '../../qaamgo/modules/sat/components/BuyCreditsBox.vue';
import BuyPackageAndSubscription from '../../qaamgo/modules/sat/components/BuyPackageAndSubscription.vue';
import { eventBus } from '../../lib/event-bus/event-bus';
import { CONTACT_US_OPEN_MODAL } from '../../lib-sat/contact-us/event';

const $ = require('jquery');
global.$ = global.jQuery = $;

import(
    /* webpackMode: "eager" */
    '../qg-main'
).then(function () {
    import(
        /* webpackMode: "lazy-once" */
        '../user/qg-contact-us'
    )
        .then(function () {
            import(
                /* webpackMode: "lazy" */
                './qg-help-functions.js'
            );
        })
        .then(function () {
            import(
                /* webpackMode: "lazy" */
                '../../pages/content/init-pricing-page.js'
            );
        })
        .then(function () {
            try {
                
            document.getElementById('get-in-touch-button').onclick = function () {
                import(
                    /* webpackMode: "lazy-once" */
                    `../user/qg-contact-us`
                ).then(function () {
                    setTimeout(() => {
                        eventBus.emit(CONTACT_US_OPEN_MODAL);
                    }, 100);
                });
            };

            } catch (e) {
                
            }

            const BuyCreditsBoxSelector = document.getElementById('BuyCreditsBoxSelector');
            if (BuyCreditsBoxSelector) {
                createApp(BuyCreditsBox).mount('#BuyCreditsBoxSelector');
            }
        });
    const BuyPackageAndSubscriptionSelector = document.getElementById('BuyPackageAndSubscriptionSelector');
    if (BuyPackageAndSubscriptionSelector) {
        createApp(BuyPackageAndSubscription).mount('#BuyPackageAndSubscriptionSelector');
    }
});
